export { default } from './PopularDepartments';